import { styled } from '@mui/material'

export const SelectWrapper:any  = styled('div')`
  width: 100%;
`
